<template>
    <div class="notFarming">
        <div class="wx_box">
            <div class="wx_main">
                <div class="head">
                    <span>根据您在园区里面设定的品种，您的品种可以参考下列方案进行日常养护，如果想用平台协助您完成日常农事管理，请按照流程完善以下相关信息，并申请开通智能化系统管理后，方能使用更多的功能。</span>
                    <el-button @click="open()" v-if="is_verify==1">前往开通</el-button>
					<el-button v-if="farm.is_check==2">正在审核中</el-button>
					<el-button @click="jump()" v-if="farm.is_check==3">审核拒绝，立即修改</el-button>
                </div>
                <div class="tab">
                    <span :class="{'active':tabNum==1}" @click="tabNum = 1">方案一</span>
                    <span :class="{'active':tabNum==2}" @click="tabNum = 2" style="display: none;">方案二</span>
                    <span :class="{'active':tabNum==3}" @click="tabNum = 3" style="display: none;">方案三</span>
                </div>
                <div class="msg_box" v-if="tabNum==1">
                    <div class="center">
                        <div class="steps">
                            <div class="item">
                                <el-button :class="{'active':buttonNum==1}" @click="buttonNum = 1">人员配置</el-button>
                            </div>
                            <div class="item">
                                <el-button :class="{'active':buttonNum==2}" @click="buttonNum = 2">园区详细信息</el-button>
                            </div>
                            <div class="item">
                                <el-button :class="{'active':buttonNum==3}" @click="buttonNum = 3">作物详细信息</el-button>
                            </div>
                            <div class="item">
                                <el-button :class="{'active':buttonNum==4}" @click="buttonNum = 4">分区建设</el-button>
                            </div>
                            <div class="item">
                                <el-button :class="{'active':buttonNum==5}" @click="buttonNum = 5">病虫害信息</el-button>
                            </div>
                            <div class="item">
                                <el-button :class="{'active':buttonNum==6}" @click="buttonNum = 6">申请开通</el-button>
                            </div>
                        </div>
                        <div class="msg" v-if="buttonNum==1">
                            配置园区参与管理人员，有总经理、项目主管与助理员三种角色由您分配，平台会分配一个职业管家给您，协助您管理好园区！
                        </div>
                        <div class="msg" v-if="buttonNum==2">
                            添加园区详细信息，为下一步智能化管理园区打好基础！
                        </div>
                        <div class="msg" v-if="buttonNum==3">
                            有了详细的作物信息，才能更好进行作物的智能化管理！
                        </div>
                        <div class="msg" v-if="buttonNum==4">
                            智能化管理是按照分区来进行的，一个分区只能有一种生命周期的作物，一个园区只能建设七个分区。
                        </div>
                        <div class="msg" v-if="buttonNum==5">
                            添加初始的病虫害信息，为智能化管理，一键生成年计划做好准备工作！
                        </div>
                        <div class="msg" v-if="buttonNum==6">
                            请选择您的述求，如果有不能满足的地方，请输入您的要求！
                        </div>
                    </div>
                </div>
                <div class="msg_box" v-if="tabNum==2"></div>
                <div class="msg_box" v-if="tabNum==3"></div>
            </div>
        </div>
        <!--        未实名认证弹窗-->
        <WxMessageBox :show="realNameShow" @save="realNameSave" @canse="realNameCanse" :btnTitles="['实名认证','确定']">
            <div slot="content">
                <div class="word marTop">
                    <p>对不起，您还为实名认证，请先实名认证之后，</p>
                    <p>才能开通智能化管理系统！</p>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
	import {getUserInfo,getFarmInfo} from '@/api/api'
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "notFarming",
        data(){
			
            return{
				farm:[],
				is_verify:'',
                tabNum:1,
                buttonNum:1,
                realNameShow:false
            }
        },
		created() {
			this.get_user_info()
			getFarmInfo(this.$route.params.id).then(resp=>{
				    if(resp.farm.is_verify==1){
						this.$router.push('/farming/'+this.$route.params.id)
					}
			            this.farm=resp.farm						  
			})
			
		},
        methods:{
			open(){
				 if(this.is_verify==1){
					  this.realNameShow=true
				 }
			},
			get_user_info(){
			    getUserInfo().then(resp=>{
			        this.is_verify=resp.is_verify
			    })
			},
			jump(){
				 this.$router.push("/applyOpen/"+this.$route.params.id)
			},
            // 未实名认证弹窗实名认证按钮
            realNameSave(){
                this.realNameShow = false
                this.$router.push('/attestation/realName');
            },
            // 未实名认证弹窗确认
            realNameCanse(){
                this.realNameShow = false
            }
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style scoped lang="less">
    .notFarming{
        .wx_box{
            .wx_main{
                padding: 37px 26px 48px 26px;
                background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                background-size: cover;
                .head{
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    span{
                        font-size: 18px;
                        font-weight: 800;
                        color: #2D99FF;
                        line-height: 25px;
                    }
                    .el-button{
                        width: 178px;
                        height: 48px;
                        line-height: 48px;
                        background: #2D99FF;
                        border-radius: 6px;
                        border: 0;
                        padding: 0;
                        text-align: center;
                        font-size: 18px;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }
                .tab{
                    display: flex;
                    justify-content: center;
                    margin-top: 36px;
                    span{
                        width: 300px;
                        height: 54px;
                        line-height: 54px;
                        background: #00407D;
                        border-radius: 4px;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #D6D6D6;
                        cursor: pointer;
                        &+span{
                            margin-left: 82px;
                        }
                    }
                    .active{
                        color: #fff;
                        background: #2D99FF;
                        position: relative;
                        &:after{
                            content: '';
                            width: 0;
                            height: 0;
                            border-left: 10px solid transparent;
                            border-right: 10px solid transparent;
                            border-bottom: 10px solid #06184D;
                            position: absolute;
                            bottom: -32px;
                            left: 50%;
                            margin-left: -10px;
                        }
                    }
                }
                .msg_box{
                    width: 100%;
                    min-height: 560px;
                    background: linear-gradient(180deg, rgba(181, 201, 255, 0.0626) 0%, rgba(151, 196, 255, 0.0626) 100%);
                    border: 2px solid #003F82;
                    margin-top: 30px;
                    .center{
                        display: flex;
                        justify-content: center;
                        padding: 50px 0;
                        .steps{
                            margin-right: 26px;
                            .item{
                                position: relative;
                                .el-button{
                                    width: 294px;
                                    height: 50px;
                                    line-height: 50px;
                                    border: 1px solid #0EA58C;
                                    text-align: center;
                                    font-size: 20px;
                                    font-weight: bold;
                                    color: #0EA58C;
                                    padding: 0;
                                    background-color: transparent;
                                }
                                &+.item{
                                    margin-top: 30px;
                                }
                                &:after{
                                    content: '';
                                    width: 50px;
                                    height: 20px;
                                    background: url("../../assets/images/down.png") no-repeat;
                                    position: absolute;
                                    bottom: -25px;
                                    left: 50%;
                                    margin-left: -25px;
                                }
                                &:last-child:after{
                                    display: none;
                                }
                                .active{
                                    color: #fff;
                                    background: #0EA58C;
                                    &:after{
                                        content: '';
                                        width: 0;
                                        height: 0;
                                        border-top: 10px solid transparent;
                                        border-bottom: 10px solid transparent;
                                        border-right: 10px solid #06184D;
                                        position: absolute;
                                        right: -26px;
                                        top: 50%;
                                        margin-top: -10px;
                                    }
                                }
                            }
                        }
                        .msg{
                            width: 742px;
                            height: 450px;
                            background: rgba(0, 14, 64, 0.5679);
                            font-size: 16px;
                            font-weight: 300;
                            color: #FFFFFF;
                            line-height: 30px;
                            padding: 13px 23px;
                            position: relative;
                        }
                    }
                }
            }
        }
        .marTop{
            margin-top: 75px;
        }
    }
</style>
